import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import PriceInputWithEarnings from '@wix/da-shared-react/pkg/DollarPriceInput/variants/PriceInputWithEarnings';
import { getMaxPrice } from '@wix/da-shared-react/pkg/redux/shared/selectors';
import { OriginalDeviationFieldName } from '../../types';
import { MIN_PRICE } from '../../validation';

interface Props {}

const PriceField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const maxPrice = useSelector(getMaxPrice);
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: OriginalDeviationFieldName.PRICE, control });
  const error = errors[OriginalDeviationFieldName.PRICE];

  return (
    <PriceInputWithEarnings
      label={t('originalDeviationPopup.form.price.label')}
      value={value}
      error={error?.message}
      validationResult={error ? 'error' : undefined}
      onChange={onChange}
      min={MIN_PRICE}
      max={maxPrice}
      forceInteger
      isRequired
      noBottomSpacing
      productType="originals"
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
